import React from "react";

interface ToggleButtonOption {
  value: string;
  label: string;
}

interface ToggleButtonProps {
  options: ToggleButtonOption[];
  selectedValue: string;
  onChange: (value: string) => void;
}

const EventEHRToggleButton: React.FC<ToggleButtonProps> = ({
  options,
  selectedValue,
  onChange,
}) => {
  return (
    <div style={{ display: "flex", gap: "14px" }}>
      {options.map((option) => (
        <div
          key={option?.value}
          onClick={() => onChange(option?.value)}
          className="cursor-pointer flex items-center bg-white"
          style={{
            gap: "10px",
            padding: "12px 18px",
            border: `1px solid ${
              selectedValue === option?.value ? "#005596" : "#D2D2D2"
            }`,
            borderRadius: "8px",
            color: selectedValue === option?.value ? "#007bff" : "#000",
            transition: "all 0.3s",
            width: "-webkit-fill-available",
          }}
        >
          <input
            type="radio"
            id={option?.value}
            name="toggle-option"
            value={option?.value}
            checked={selectedValue === option?.value}
            onChange={() => onChange(option?.value)}
            className="w-[20px] h-[20px] top-[2px] left-[2px] border-[#95929E] accent-[#005596] cursor-pointer"
          />
          <label
            htmlFor={option?.value}
            className="font-weight-500 font-size-14px cursor-pointer"
            style={{
              color: selectedValue === option?.value ? "#005596" : "#727272",
            }}
          >
            {option?.label}
          </label>
        </div>
      ))}
    </div>
  );
};

export default EventEHRToggleButton;
